// Static imports
import ReportsMain from '@/views/member/reports'
import AlltotalList from '@/views/member/reports/pages/alltotalList'
import AlltotalList2 from '@/views/member/reports/pages/alltotalList2'
import UsertotalList from '@/views/member/reports/pages/usertotalList'
import WinLose from '@/views/member/reports/pages/winlose'
import TermsReport from '@/views/member/reports/pages/termsReport'
import GamesReport from '@/views/member/reports/pages/gamesReport'
import Daily from '@/views/member/reports/pages/daily'
import TotalList from '@/views/member/reports/pages/totalList'
import PartnerBalance from '@/views/member/reports/pages/partnerBalance'
import DailySettlement from '@/views/member/reports/pages/dailySettlement'
import MonthlySettlement from '@/views/member/reports/pages/monthlySettlement'

export default {
  name: 'reports',
  path: '/reports',
  component: ReportsMain,
  meta: {
    layout: 'default',
    isActive: false,
    text: '정산관리',
    icon: 'icon_report',
    code: 'LV080000'
  },
  children: [
    {
      name: 'alltotalList',
      path: '/reports/alltotalList',
      component: AlltotalList,
      meta: {
        menuMember: true,
        text: '파트너정산내역',
        code: 'LV080800'
      }
    },
    {
      name: 'alltotalList2',
      path: '/reports/alltotalList2',
      component: AlltotalList2,
      meta: {
        menuMember: true,
        text: '파트너정산내역(날짜별)',
        code: 'LV080600'
      }
    },
    {
      name: 'usertotalList',
      path: '/reports/usertotalList',
      component: UsertotalList,
      meta: {
        menuMember: true,
        text: '회원정산내역',
        code: 'LV080900'
      }
    },
    {
      name: 'memWinLose',
      path: '/reports/winlose',
      component: WinLose,
      meta: {
        menuMember: false,
        text: '회원승패',
        code: 'LV080100'
      }
    },
    {
      name: 'termsReport',
      path: '/reports/termsReport',
      component: TermsReport,
      meta: {
        menuMember: false,
        text: '기간별 현황',
        code: 'LV080200'
      }
    },
    {
      name: 'gamesReport',
      path: '/reports/gamesReport',
      component: GamesReport,
      meta: {
        menuMember: true,
        text: '게임별 리포트',
        code: 'LV080300'
      }
    },
    {
      name: 'dailyReport',
      path: '/reports/dailyReport',
      component: Daily,
      meta: {
        menuMember: true,
        text: '일자별 리포트',
        code: 'LV080400'
      }
    },
    {
      name: 'totalList',
      path: '/reports/totalList',
      component: TotalList,
      meta: {
        menuMember: false,
        text: '거래 내역 조회',
        code: 'LV080500'
      }
    },
    {
      name: 'companyBalance',
      path: '/reports/companyBalance',
      component: PartnerBalance,
      meta: {
        menuMember: false,
        text: '보유머니 현황',
        code: 'LV080700'
      }
    },
    {
      name: 'dailySettlement',
      path: '/reports/dailySettlement',
      component: DailySettlement,
      meta: {
        menuMember: true,
        text: '일별 정산'
      }
    },
    {
      name: 'monthlySettlement',
      path: '/reports/monthlySettlement',
      component: MonthlySettlement,
      meta: {
        menuMember: true,
        text: '월별 정산'
      }
    }
    // {
    //   name: 'dayReport',
    //   path: '/reports/old_day',
    //   component: () => import('@/views/member/reports/pages/old_day'),
    //   meta: {
    //     menuMember: true,
    //     text: '날짜별 정산내역'
    //   }
    // },
    // {
    //   name: 'WMReport',
    //   path: '/reports/old_weekMonth',
    //   component: () => import('@/views/member/reports/pages/old_weekMonth'),
    //   meta: {
    //     menuMember: true,
    //     text: '주,월별 정산내역'
    //   }
    // }
  ]
}
